/* eslint-disable */
/* istanbul ignore file */
/* THIS FILE IS AUTOGENERATED - DO NOT EDIT */
import * as Types from '@shure/shared/angular/data-access/system-api/core';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type IntellimixDeviceFragment = { id: string, virtual: boolean, status: Types.DeviceStatus, compatibility: Types.CompatibilityLevel, description: { model: string, constraints: { virtualAcousticBoundary: { sensitivity: { range: { max: number, min: number, step: number } } | null } | null, conferencingOperationMode: { mode: { options: Array<Types.ConferencingOperationMode> } } | null }, features: { coverageMode: { supported: boolean }, audioChannels: { supported: boolean }, virtualAcousticBoundary: { supported: boolean }, virtual: { supported: boolean }, automixGainMetering: { supported: boolean }, allIntellimixBypass: { supported: boolean }, allEqualizersBypass: { supported: boolean }, audioCoverageAreas: { supported: boolean }, danteAudioNetworkAccess: { supported: boolean }, license: { supported: boolean }, loudspeaker: { supported: boolean }, ethernetPowerSource: { supported: boolean }, conferencingOperationMode: { supported: boolean }, dectRfSpectrumScan: { supported: boolean } } }, features: { audioChannelCount: { count: number } | null, license: { info: Array<{ state: Types.LicenseState, inUse: boolean | null, inGrace: boolean | null, inWarning: boolean | null, graceExpiresIn: string | null, type: Types.LicenseType | null }> } | null, coverageMode: { coverageMode: Types.CoverageMode } | null, audioChannels: { audioChannels: Array<IntellimixAutomixChannelFragment> } | null, virtualAcousticBoundary: { enabled: boolean, sensitivity: number } | null, virtual: { virtual: boolean } | null, automixGainMetering: { enabled: boolean } | null, allIntellimixBypass: { bypassed: boolean } | null, allEqualizersBypass: { bypassed: boolean } | null, authentication: { credentials: Array<{ accessLevel: string, credentialsState: Types.CredentialsState }> | null } | null, danteAudioNetworkAccess: { changesAllowed: boolean, factoryResetAllowed: boolean } | null, firmware: { valid: boolean, version: string } | null, loudspeaker: { available: boolean, enabled: boolean } | null, ethernetPowerSource: { type: Types.EthernetPowerSourceType } | null, conferencingOperationMode: { mode: Types.ConferencingOperationMode } | null, dectRfSpectrumScan: { inProgress: boolean } | null } };

export type IntellimixDeviceChangeFragment = { id: string, features:
    | { allEqualizersBypass: { bypassed: boolean } | null }
    | { allIntellimixBypass: { bypassed: boolean } | null }
    | { audioChannelCount: { count: number } | null }
    | { authentication: { credentials: Array<{ accessLevel: string, credentialsState: Types.CredentialsState }> | null } | null }
    | { automixGainMetering: { enabled: boolean } | null }
    | { conferencingOperationMode: { mode: Types.ConferencingOperationMode } | null }
    | { coverageMode: { coverageMode: Types.CoverageMode } | null }
    | { danteAudioNetworkAccess: { changesAllowed: boolean, factoryResetAllowed: boolean } | null }
    | { dectRfSpectrumScan: { inProgress: boolean } | null }
    | { license: { info: Array<{ state: Types.LicenseState, inUse: boolean | null, inGrace: boolean | null, inWarning: boolean | null, graceExpiresIn: string | null, type: Types.LicenseType | null }> } | null }
    | { virtualAcousticBoundary: { enabled: boolean, sensitivity: number } | null }
    | Record<PropertyKey, never>
   };

export type IntellimixInputChannelFragment = { id: string, description: { groupName: string, role: Types.AudioChannelRole, features: { danteEncryptionStatus: { supported: boolean }, automaticGainControl: { supported: boolean }, name: { supported: boolean }, automixerInputSendToMonoMix: { supported: boolean }, automixerInputPriority: { supported: boolean }, automixerInputAlwaysOn: { supported: boolean }, acousticEchoCancellationPeak: { supported: boolean }, acousticEchoCancellationRms: { supported: boolean }, automixerInputPeak: { supported: boolean }, automixerInputRms: { supported: boolean }, postGateGain: { supported: boolean }, postGateMute: { supported: boolean }, directOutputTapPoint: { supported: boolean }, micPolarPattern: { supported: boolean }, lobeConfiguration: { supported: boolean }, postGateSolo: { supported: boolean }, analogInputUse: { supported: boolean }, automixerChannelActive: { supported: boolean } }, constraints: { gain: { gain: { range: { min: number, max: number, step: number } } } | null, postGateGain: { gain: { range: { min: number, max: number, step: number } } } | null, directOutputTapPoint: { tapPoint: { options: Array<Types.DirectOutputTapPoint> } | null } | null, name: { name: { pattern: string } } | null } }, features: { danteEncryptionStatus: { status: Types.DanteAudioEncryptionStatus } | null, name: { name: string } | null, automaticGainControl: { enabled: boolean } | null, automixerInputAlwaysOn: { enabled: boolean } | null, automixerInputPriority: { enabled: boolean } | null, automixerInputSendToMonoMix: { enabled: boolean } | null, postGateGain: { gain: number } | null, postGateMute: { muted: boolean } | null, directOutputTapPoint: { tapPoint: Types.DirectOutputTapPoint } | null, micPolarPattern: { pattern: Types.MicPolarPattern } | null, lobeConfiguration: { enabled: boolean } | null, postGateSolo: { enabled: boolean } | null, analogInputUse: { mode: Types.AnalogInputUseMode } | null, automixerChannelActive: { enabled: boolean } | null } };

export type IntellimixInputChannelChangeFragment = { id: string, features:
    | { analogInputUse: { mode: Types.AnalogInputUseMode } | null }
    | { automaticGainControl: { enabled: boolean } | null }
    | { automixerChannelActive: { enabled: boolean } | null }
    | { automixerInputAlwaysOn: { enabled: boolean } | null }
    | { automixerInputPriority: { enabled: boolean } | null }
    | { automixerInputSendToMonoMix: { enabled: boolean } | null }
    | { danteEncryptionStatus: { status: Types.DanteAudioEncryptionStatus } | null }
    | { directOutputTapPoint: { tapPoint: Types.DirectOutputTapPoint } | null }
    | { lobeConfiguration: { enabled: boolean } | null }
    | { micPolarPattern: { pattern: Types.MicPolarPattern } | null }
    | { name: { name: string } | null }
    | { postGateGain: { gain: number } | null }
    | { postGateMute: { muted: boolean } | null }
    | { postGateSolo: { enabled: boolean } | null }
    | Record<PropertyKey, never>
   };

export type IntellimixBasicAutomixChannelFragment = { id: string, description: { groupName: string, role: Types.AudioChannelRole, features: { name: { supported: boolean }, danteEncryptionStatus: { supported: boolean }, postGateMute: { supported: boolean } } }, features: { name: { name: string } | null, danteEncryptionStatus: { status: Types.DanteAudioEncryptionStatus } | null, postGateMute: { muted: boolean } | null } };

export type IntellimixBasicAutomixChannelChangeFragment = { id: string, features:
    | { danteEncryptionStatus: { status: Types.DanteAudioEncryptionStatus } | null }
    | { name: { name: string } | null }
    | { postGateMute: { muted: boolean } | null }
    | Record<PropertyKey, never>
   };

export type IntellimixAutomixChannelFragment = { id: string, description: { groupName: string, role: Types.AudioChannelRole, constraints: { automixer: { gatingSensitivity: { range: { min: number, max: number, step: number } }, holdTime: { range: { min: string, max: string, step: string } }, offAttenuation: { range: { min: number, max: number, step: number } }, mode: { options: Array<Types.AutomixMode> } } | null, micOptimization: { mode: { options: Array<Types.MicOptimizationMode> } } | null, gain: { gain: { range: { min: number, max: number, step: number } } } | null, postGateGain: { gain: { range: { min: number, max: number, step: number } } } | null, voiceActivityDetectionSensitivity: { sensitivity: { options: Array<Types.NoiseDetectionSensitivity> } } | null, voiceActivityDetectionNoiseReduction: { level: { options: Array<Types.NoiseRemovalLevel> } } | null, name: { name: { pattern: string } } | null }, features: { name: { supported: boolean }, danteEncryptionStatus: { supported: boolean }, gain: { supported: boolean }, postGateGain: { supported: boolean }, mute: { supported: boolean }, postGateMute: { supported: boolean }, automaticGainControl: { supported: boolean }, delay: { supported: boolean }, noiseReduction: { supported: boolean }, compressor: { supported: boolean }, acousticEchoCancellation: { supported: boolean }, equalizer: { supported: boolean }, automixer: { supported: boolean }, micPolarPattern: { supported: boolean }, lobeConfiguration: { supported: boolean }, micOptimization: { supported: boolean }, automixSourceSelector: { supported: boolean }, voiceActivityDetectionSensitivity: { supported: boolean }, voiceActivityDetectionNoiseReduction: { supported: boolean }, analogInputUse: { supported: boolean }, automixerChannelActive: { supported: boolean }, deverb: { supported: boolean }, denoiser: { supported: boolean } } }, features: { name: { name: string } | null, danteEncryptionStatus: { status: Types.DanteAudioEncryptionStatus } | null, gain: { gain: number } | null, postGateGain: { gain: number } | null, mute: { muted: boolean } | null, postGateMute: { muted: boolean } | null, automaticGainControl: { enabled: boolean } | null, delay: { enabled: boolean } | null, noiseReduction: { enabled: boolean } | null, compressor: { enabled: boolean | null } | null, acousticEchoCancellation: { enabled: boolean } | null, equalizer: { enabled: boolean | null, filters: Array<IntellimixEqualizerFragment> } | null, automixer: { enabled: boolean | null, mode: Types.AutomixMode, leaveLastChannelOn: boolean, offAttenuation: number, holdTime: string, gatingSensitivity: number, maxOpenChannels: number, maxOpenChannelsRange: { min: number, max: number, step: number } } | null, micOptimization: { mode: Types.MicOptimizationMode } | null, automixSourceSelector: { source: { id: string } | null } | null, micPolarPattern: { pattern: Types.MicPolarPattern } | null, lobeConfiguration: { enabled: boolean } | null, voiceActivityDetectionSensitivity: { sensitivity: Types.NoiseDetectionSensitivity } | null, voiceActivityDetectionNoiseReduction: { level: Types.NoiseRemovalLevel } | null, analogInputUse: { mode: Types.AnalogInputUseMode } | null, automixerChannelActive: { enabled: boolean } | null, deverb: { enabled: boolean, intensity: Types.DeverbIntensity } | null, denoiser: { enabled: boolean, level: Types.DenoiserLevel } | null } };

export type IntellimixAutomixChannelChangeFragment = { id: string, features:
    | { acousticEchoCancellation: { enabled: boolean } | null }
    | { automaticGainControl: { enabled: boolean } | null }
    | { automixSourceSelector: { source: { id: string } | null } | null }
    | { automixer: { enabled: boolean | null, gatingSensitivity: number, holdTime: string, leaveLastChannelOn: boolean, maxOpenChannels: number, mode: Types.AutomixMode, offAttenuation: number } | null }
    | { automixerChannelActive: { enabled: boolean } | null }
    | { compressor: { enabled: boolean | null } | null }
    | { danteEncryptionStatus: { status: Types.DanteAudioEncryptionStatus } | null }
    | { delay: { enabled: boolean } | null }
    | { denoiser: { enabled: boolean, level: Types.DenoiserLevel } | null }
    | { deverb: { enabled: boolean, intensity: Types.DeverbIntensity } | null }
    | { equalizer: { enabled: boolean | null, filters: Array<IntellimixEqualizerFragment> } | null }
    | { gain: { gain: number } | null }
    | { lobeConfiguration: { enabled: boolean } | null }
    | { micOptimization: { mode: Types.MicOptimizationMode } | null }
    | { micPolarPattern: { pattern: Types.MicPolarPattern } | null }
    | { mute: { muted: boolean } | null }
    | { name: { name: string } | null }
    | { noiseReduction: { enabled: boolean } | null }
    | { postGateGain: { gain: number } | null }
    | { postGateMute: { muted: boolean } | null }
    | { voiceActivityDetectionNoiseReduction: { level: Types.NoiseRemovalLevel } | null }
    | { voiceActivityDetectionSensitivity: { sensitivity: Types.NoiseDetectionSensitivity } | null }
    | Record<PropertyKey, never>
   };

export type IntellimixEqualizerFragment = { id: string, description: { constraints: { configuration: { filterType: { options: Array<Types.EqualizerFilterType> | null } | null } | null }, features: { configuration: { supported: boolean } } }, features: { configuration: { enabled: boolean } | null } };

export type IntellimixEqualizerFilterChangeFragment = { id: string, features:
    | { configuration: { enabled: boolean } | null }
    | Record<PropertyKey, never>
   };

export type IntellimixDeviceQueryVariables = Types.Exact<{
  deviceId: Types.Scalars['ID']['input'];
}>;


export type IntellimixDeviceQueryOpResult = { node:
    | IntellimixDeviceFragment
    | Record<PropertyKey, never>
   };

export type IntellimixInputChannelQueryVariables = Types.Exact<{
  channelId: Types.Scalars['ID']['input'];
}>;


export type IntellimixInputChannelQueryOpResult = { node:
    | IntellimixInputChannelFragment
    | Record<PropertyKey, never>
   };

export type IntellimixBasicAutomixChannelQueryVariables = Types.Exact<{
  channelId: Types.Scalars['ID']['input'];
}>;


export type IntellimixBasicAutomixChannelQueryOpResult = { node:
    | IntellimixBasicAutomixChannelFragment
    | Record<PropertyKey, never>
   };

export type IntellimixAutomixChannelQueryVariables = Types.Exact<{
  channelId: Types.Scalars['ID']['input'];
}>;


export type IntellimixAutomixChannelQueryOpResult = { node:
    | IntellimixAutomixChannelFragment
    | Record<PropertyKey, never>
   };

export type IntellimixDeviceSubscriptionVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  types: Array<Types.NodeChangeType> | Types.NodeChangeType;
}>;


export type IntellimixDeviceSubscriptionOpResult = { nodeChanges:
    | IntellimixDeviceFragment
    | IntellimixDeviceChangeFragment
    | Record<PropertyKey, never>
   };

export type IntellimixInputChannelSubscriptionVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  types: Array<Types.NodeChangeType> | Types.NodeChangeType;
}>;


export type IntellimixInputChannelSubscriptionOpResult = { nodeChanges:
    | IntellimixInputChannelFragment
    | IntellimixInputChannelChangeFragment
    | Record<PropertyKey, never>
   };

export type IntellimixBasicAutomixChannelSubscriptionVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  types: Array<Types.NodeChangeType> | Types.NodeChangeType;
}>;


export type IntellimixBasicAutomixChannelSubscriptionOpResult = { nodeChanges:
    | IntellimixBasicAutomixChannelFragment
    | IntellimixBasicAutomixChannelChangeFragment
    | Record<PropertyKey, never>
   };

export type IntellimixAutomixChannelSubscriptionVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  types: Array<Types.NodeChangeType> | Types.NodeChangeType;
}>;


export type IntellimixAutomixChannelSubscriptionOpResult = { nodeChanges:
    | IntellimixAutomixChannelFragment
    | IntellimixAutomixChannelChangeFragment
    | Record<PropertyKey, never>
   };

export type IntellimixEqualizerSubscriptionVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
  types: Array<Types.NodeChangeType> | Types.NodeChangeType;
}>;


export type IntellimixEqualizerSubscriptionOpResult = { nodeChanges:
    | IntellimixEqualizerFragment
    | IntellimixEqualizerFilterChangeFragment
    | Record<PropertyKey, never>
   };

export type IntellimixChannelMutationVariables = Types.Exact<{
  updates: Array<Types.NodeUpdateInput> | Types.NodeUpdateInput;
  injectKeyring: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type IntellimixChannelMutationOpResult = { updateNodes: Array<
    | { audioChannel: (
        IntellimixInputChannelFragment
        & IntellimixAutomixChannelFragment
      ) | null, error: { code: Types.ErrorCode, message: string } | null }
    | Record<PropertyKey, never>
  > };

export type IntellimixDeviceMutationVariables = Types.Exact<{
  updates: Array<Types.NodeUpdateInput> | Types.NodeUpdateInput;
  injectKeyring: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type IntellimixDeviceMutationOpResult = { updateNodes: Array<
    | { error: { code: Types.ErrorCode, message: string } | null }
    | Record<PropertyKey, never>
  > };

export type IntellimixDeviceOperationModeMutationVariables = Types.Exact<{
  updates: Array<Types.NodeUpdateInput> | Types.NodeUpdateInput;
  injectKeyring: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type IntellimixDeviceOperationModeMutationOpResult = { updateNodes: Array<
    | { error: { code: Types.ErrorCode, message: string } | null }
    | Record<PropertyKey, never>
  > };

export type IntellimixDeviceAutomixGainMeteringMutationVariables = Types.Exact<{
  updates: Array<Types.NodeUpdateInput> | Types.NodeUpdateInput;
  injectKeyring: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type IntellimixDeviceAutomixGainMeteringMutationOpResult = { updateNodes: Array<
    | { device: { features: { automixGainMetering: { enabled: boolean } | null } } | null, error: { code: Types.ErrorCode, message: string } | null }
    | Record<PropertyKey, never>
  > };

export type ResetAutomixerDefaultsMutationVariables = Types.Exact<{
  channelId: Types.Scalars['ID']['input'];
  scope: Types.DeviceResetScope;
  injectKeyring: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type ResetAutomixerDefaultsMutationOpResult = { resetDevice:
    | { error: { code: Types.ErrorCode, message: string } | null }
    | Record<PropertyKey, never>
   };

export type UpdateAutomixerSourceSelectorVariables = Types.Exact<{
  input: Types.AutomixSourceSelectorInput;
  injectKeyring: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type UpdateAutomixerSourceSelectorOpResult = { updateAutomixSourceSelector: { error: { code: Types.ErrorCode, message: string } | null } };

export const IntellimixEqualizerFragment = gql`
    fragment IntellimixEqualizerFragment on EqualizerFilter {
  id
  description {
    constraints {
      configuration {
        filterType {
          options
        }
      }
    }
    features {
      configuration {
        supported
      }
    }
  }
  features {
    configuration {
      enabled
    }
  }
}
    `;
export const IntellimixAutomixChannelFragment = gql`
    fragment IntellimixAutomixChannelFragment on AudioChannel {
  id
  description {
    groupName
    role
    constraints {
      automixer {
        gatingSensitivity {
          range {
            min
            max
            step
          }
        }
        holdTime {
          range {
            min
            max
            step
          }
        }
        offAttenuation {
          range {
            min
            max
            step
          }
        }
        mode {
          options
        }
      }
      micOptimization {
        mode {
          options
        }
      }
      gain {
        gain {
          range {
            min
            max
            step
          }
        }
      }
      postGateGain {
        gain {
          range {
            min
            max
            step
          }
        }
      }
      voiceActivityDetectionSensitivity {
        sensitivity {
          options
        }
      }
      voiceActivityDetectionNoiseReduction {
        level {
          options
        }
      }
      name {
        name {
          pattern
        }
      }
    }
    features {
      name {
        supported
      }
      danteEncryptionStatus {
        supported
      }
      gain {
        supported
      }
      postGateGain {
        supported
      }
      mute {
        supported
      }
      postGateMute {
        supported
      }
      automaticGainControl {
        supported
      }
      delay {
        supported
      }
      noiseReduction {
        supported
      }
      compressor {
        supported
      }
      acousticEchoCancellation {
        supported
      }
      equalizer {
        supported
      }
      automixer {
        supported
      }
      micPolarPattern {
        supported
      }
      lobeConfiguration {
        supported
      }
      micOptimization {
        supported
      }
      automixSourceSelector {
        supported
      }
      voiceActivityDetectionSensitivity {
        supported
      }
      voiceActivityDetectionNoiseReduction {
        supported
      }
      analogInputUse {
        supported
      }
      automixerChannelActive {
        supported
      }
      deverb {
        supported
      }
      denoiser {
        supported
      }
    }
  }
  features {
    name {
      name
    }
    danteEncryptionStatus {
      status
    }
    gain {
      gain
    }
    postGateGain {
      gain
    }
    mute {
      muted
    }
    postGateMute {
      muted
    }
    automaticGainControl {
      enabled
    }
    delay {
      enabled
    }
    noiseReduction {
      enabled
    }
    compressor {
      enabled
    }
    acousticEchoCancellation {
      enabled
    }
    equalizer {
      enabled
      filters {
        ...IntellimixEqualizerFragment
      }
    }
    automixer {
      enabled
      mode
      leaveLastChannelOn
      offAttenuation
      holdTime
      gatingSensitivity
      maxOpenChannels
      maxOpenChannelsRange {
        min
        max
        step
      }
    }
    micOptimization {
      mode
    }
    automixSourceSelector {
      source {
        id
      }
    }
    micPolarPattern {
      pattern
    }
    lobeConfiguration {
      enabled
    }
    voiceActivityDetectionSensitivity {
      sensitivity
    }
    voiceActivityDetectionNoiseReduction {
      level
    }
    analogInputUse {
      mode
    }
    automixerChannelActive {
      enabled
    }
    deverb {
      enabled
      intensity
    }
    denoiser {
      enabled
      level
    }
  }
}
    ${IntellimixEqualizerFragment}`;
export const IntellimixDeviceFragment = gql`
    fragment IntellimixDeviceFragment on Device {
  id
  virtual
  status
  compatibility
  description {
    model
    constraints {
      virtualAcousticBoundary {
        sensitivity {
          range {
            max
            min
            step
          }
        }
      }
      conferencingOperationMode {
        mode {
          options
        }
      }
    }
    features {
      coverageMode {
        supported
      }
      audioChannels {
        supported
      }
      virtualAcousticBoundary {
        supported
      }
      virtual {
        supported
      }
      automixGainMetering {
        supported
      }
      allIntellimixBypass {
        supported
      }
      allEqualizersBypass {
        supported
      }
      audioCoverageAreas {
        supported
      }
      danteAudioNetworkAccess {
        supported
      }
      license {
        supported
      }
      loudspeaker {
        supported
      }
      ethernetPowerSource {
        supported
      }
      conferencingOperationMode {
        supported
      }
      dectRfSpectrumScan {
        supported
      }
    }
  }
  features {
    audioChannelCount {
      count
    }
    license {
      info {
        state
        inUse
        inGrace
        inWarning
        graceExpiresIn
        type
      }
    }
    coverageMode {
      coverageMode
    }
    audioChannels {
      audioChannels {
        ...IntellimixAutomixChannelFragment
      }
    }
    virtualAcousticBoundary {
      enabled
      sensitivity
    }
    virtual {
      virtual
    }
    automixGainMetering {
      enabled
    }
    allIntellimixBypass {
      bypassed
    }
    allEqualizersBypass {
      bypassed
    }
    authentication {
      credentials {
        accessLevel
        credentialsState
      }
    }
    danteAudioNetworkAccess {
      changesAllowed
      factoryResetAllowed
    }
    firmware {
      valid
      version
    }
    loudspeaker {
      available
      enabled
    }
    ethernetPowerSource {
      type
    }
    conferencingOperationMode {
      mode
    }
    dectRfSpectrumScan {
      inProgress
    }
  }
}
    ${IntellimixAutomixChannelFragment}`;
export const IntellimixDeviceChangeFragment = gql`
    fragment IntellimixDeviceChangeFragment on DeviceChange {
  id
  features {
    ... on DeviceAudioChannelCountChange {
      audioChannelCount {
        count
      }
    }
    ... on DeviceLicenseChange {
      license {
        info {
          state
          inUse
          inGrace
          inWarning
          graceExpiresIn
          type
        }
      }
    }
    ... on DeviceCoverageModeChange {
      coverageMode {
        coverageMode
      }
    }
    ... on DeviceAutomixGainMeteringChange {
      automixGainMetering {
        enabled
      }
    }
    ... on DeviceVirtualAcousticBoundaryChange {
      virtualAcousticBoundary {
        enabled
        sensitivity
      }
    }
    ... on DeviceAllIntellimixBypassChange {
      allIntellimixBypass {
        bypassed
      }
    }
    ... on DeviceAllEqualizersBypassChange {
      allEqualizersBypass {
        bypassed
      }
    }
    ... on DeviceAuthenticationChange {
      authentication {
        credentials {
          accessLevel
          credentialsState
        }
      }
    }
    ... on DeviceDanteAudioNetworkAccessChange {
      danteAudioNetworkAccess {
        changesAllowed
        factoryResetAllowed
      }
    }
    ... on DeviceConferencingOperationModeChange {
      conferencingOperationMode {
        mode
      }
    }
    ... on DeviceDectRfSpectrumScanChange {
      dectRfSpectrumScan {
        inProgress
      }
    }
  }
}
    `;
export const IntellimixInputChannelFragment = gql`
    fragment IntellimixInputChannelFragment on AudioChannel {
  id
  description {
    groupName
    role
    features {
      danteEncryptionStatus {
        supported
      }
      automaticGainControl {
        supported
      }
      name {
        supported
      }
      automixerInputSendToMonoMix {
        supported
      }
      automixerInputPriority {
        supported
      }
      automixerInputAlwaysOn {
        supported
      }
      acousticEchoCancellationPeak {
        supported
      }
      acousticEchoCancellationRms {
        supported
      }
      automixerInputPeak {
        supported
      }
      automixerInputRms {
        supported
      }
      postGateGain {
        supported
      }
      postGateMute {
        supported
      }
      directOutputTapPoint {
        supported
      }
      micPolarPattern {
        supported
      }
      lobeConfiguration {
        supported
      }
      postGateSolo {
        supported
      }
      analogInputUse {
        supported
      }
      automixerChannelActive {
        supported
      }
    }
    constraints {
      gain {
        gain {
          range {
            min
            max
            step
          }
        }
      }
      postGateGain {
        gain {
          range {
            min
            max
            step
          }
        }
      }
      directOutputTapPoint {
        tapPoint {
          options
        }
      }
      name {
        name {
          pattern
        }
      }
    }
  }
  features {
    danteEncryptionStatus {
      status
    }
    name {
      name
    }
    automaticGainControl {
      enabled
    }
    automixerInputAlwaysOn {
      enabled
    }
    automixerInputPriority {
      enabled
    }
    automixerInputSendToMonoMix {
      enabled
    }
    postGateGain {
      gain
    }
    postGateMute {
      muted
    }
    directOutputTapPoint {
      tapPoint
    }
    micPolarPattern {
      pattern
    }
    lobeConfiguration {
      enabled
    }
    postGateSolo {
      enabled
    }
    analogInputUse {
      mode
    }
    automixerChannelActive {
      enabled
    }
  }
}
    `;
export const IntellimixInputChannelChangeFragment = gql`
    fragment IntellimixInputChannelChangeFragment on AudioChannelChange {
  id
  features {
    ... on AudioChannelDanteEncryptionStatusChange {
      danteEncryptionStatus {
        status
      }
    }
    ... on AudioChannelNameChange {
      name {
        name
      }
    }
    ... on AudioChannelAutomaticGainControlChange {
      automaticGainControl {
        enabled
      }
    }
    ... on AudioChannelAutomixerInputAlwaysOnChange {
      automixerInputAlwaysOn {
        enabled
      }
    }
    ... on AudioChannelAutomixerInputPriorityChange {
      automixerInputPriority {
        enabled
      }
    }
    ... on AudioChannelAutomixerInputSendToMonoMixChange {
      automixerInputSendToMonoMix {
        enabled
      }
    }
    ... on AudioChannelPostGateGainChange {
      postGateGain {
        gain
      }
    }
    ... on AudioChannelPostGateMuteChange {
      postGateMute {
        muted
      }
    }
    ... on AudioChannelDirectOutputTapPointChange {
      directOutputTapPoint {
        tapPoint
      }
    }
    ... on AudioChannelMicPolarPatternChange {
      micPolarPattern {
        pattern
      }
    }
    ... on AudioChannelLobeConfigurationChange {
      lobeConfiguration {
        enabled
      }
    }
    ... on AudioChannelPostGateSoloChange {
      postGateSolo {
        enabled
      }
    }
    ... on AudioChannelAnalogInputUseChange {
      analogInputUse {
        mode
      }
    }
    ... on AudioChannelAutomixerChannelActiveChange {
      automixerChannelActive {
        enabled
      }
    }
  }
}
    `;
export const IntellimixBasicAutomixChannelFragment = gql`
    fragment IntellimixBasicAutomixChannelFragment on AudioChannel {
  id
  description {
    groupName
    role
    features {
      name {
        supported
      }
      danteEncryptionStatus {
        supported
      }
      postGateMute {
        supported
      }
    }
  }
  features {
    name {
      name
    }
    danteEncryptionStatus {
      status
    }
    postGateMute {
      muted
    }
  }
}
    `;
export const IntellimixBasicAutomixChannelChangeFragment = gql`
    fragment IntellimixBasicAutomixChannelChangeFragment on AudioChannelChange {
  id
  features {
    ... on AudioChannelNameChange {
      name {
        name
      }
    }
    ... on AudioChannelDanteEncryptionStatusChange {
      danteEncryptionStatus {
        status
      }
    }
    ... on AudioChannelPostGateMuteChange {
      postGateMute {
        muted
      }
    }
  }
}
    `;
export const IntellimixAutomixChannelChangeFragment = gql`
    fragment IntellimixAutomixChannelChangeFragment on AudioChannelChange {
  id
  features {
    ... on AudioChannelNameChange {
      name {
        name
      }
    }
    ... on AudioChannelMuteChange {
      mute {
        muted
      }
    }
    ... on AudioChannelPostGateMuteChange {
      postGateMute {
        muted
      }
    }
    ... on AudioChannelGainChange {
      gain {
        gain
      }
    }
    ... on AudioChannelPostGateGainChange {
      postGateGain {
        gain
      }
    }
    ... on AudioChannelDanteEncryptionStatusChange {
      danteEncryptionStatus {
        status
      }
    }
    ... on AudioChannelAutomixerChange {
      automixer {
        enabled
        gatingSensitivity
        holdTime
        leaveLastChannelOn
        maxOpenChannels
        mode
        offAttenuation
      }
    }
    ... on AudioChannelCompressorChange {
      compressor {
        enabled
      }
    }
    ... on AudioChannelDelayChange {
      delay {
        enabled
      }
    }
    ... on AudioChannelAutomaticGainControlChange {
      automaticGainControl {
        enabled
      }
    }
    ... on AudioChannelAcousticEchoCancellationChange {
      acousticEchoCancellation {
        enabled
      }
    }
    ... on AudioChannelNoiseReductionChange {
      noiseReduction {
        enabled
      }
    }
    ... on AudioChannelDenoiserChange {
      denoiser {
        enabled
        level
      }
    }
    ... on AudioChannelDeverbChange {
      deverb {
        enabled
        intensity
      }
    }
    ... on AudioChannelAutomixSourceSelectorChange {
      automixSourceSelector {
        source {
          id
        }
      }
    }
    ... on AudioChannelMicOptimizationChange {
      micOptimization {
        mode
      }
    }
    ... on AudioChannelMicPolarPatternChange {
      micPolarPattern {
        pattern
      }
    }
    ... on AudioChannelLobeConfigurationChange {
      lobeConfiguration {
        enabled
      }
    }
    ... on AudioChannelEqualizerChange {
      equalizer {
        enabled
        filters {
          ...IntellimixEqualizerFragment
        }
      }
    }
    ... on AudioChannelVoiceActivityDetectionSensitivityChange {
      voiceActivityDetectionSensitivity {
        sensitivity
      }
    }
    ... on AudioChannelVoiceActivityDetectionNoiseReductionChange {
      voiceActivityDetectionNoiseReduction {
        level
      }
    }
    ... on AudioChannelAutomixerChannelActiveChange {
      automixerChannelActive {
        enabled
      }
    }
  }
}
    ${IntellimixEqualizerFragment}`;
export const IntellimixEqualizerFilterChangeFragment = gql`
    fragment IntellimixEqualizerFilterChangeFragment on EqualizerFilterChange {
  id
  features {
    ... on EqualizerFilterConfigurationChange {
      configuration {
        enabled
      }
    }
  }
}
    `;
export const IntellimixDeviceQueryDocument = gql`
    query IntellimixDeviceQuery($deviceId: ID!) {
  node(id: $deviceId) {
    ...IntellimixDeviceFragment
  }
}
    ${IntellimixDeviceFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class IntellimixDeviceQueryGQL extends Apollo.Query<IntellimixDeviceQueryOpResult, IntellimixDeviceQueryVariables> {
    override document = IntellimixDeviceQueryDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const IntellimixInputChannelQueryDocument = gql`
    query IntellimixInputChannelQuery($channelId: ID!) {
  node(id: $channelId) {
    ...IntellimixInputChannelFragment
  }
}
    ${IntellimixInputChannelFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class IntellimixInputChannelQueryGQL extends Apollo.Query<IntellimixInputChannelQueryOpResult, IntellimixInputChannelQueryVariables> {
    override document = IntellimixInputChannelQueryDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const IntellimixBasicAutomixChannelQueryDocument = gql`
    query IntellimixBasicAutomixChannelQuery($channelId: ID!) {
  node(id: $channelId) {
    ...IntellimixBasicAutomixChannelFragment
  }
}
    ${IntellimixBasicAutomixChannelFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class IntellimixBasicAutomixChannelQueryGQL extends Apollo.Query<IntellimixBasicAutomixChannelQueryOpResult, IntellimixBasicAutomixChannelQueryVariables> {
    override document = IntellimixBasicAutomixChannelQueryDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const IntellimixAutomixChannelQueryDocument = gql`
    query IntellimixAutomixChannelQuery($channelId: ID!) {
  node(id: $channelId) {
    ...IntellimixAutomixChannelFragment
  }
}
    ${IntellimixAutomixChannelFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class IntellimixAutomixChannelQueryGQL extends Apollo.Query<IntellimixAutomixChannelQueryOpResult, IntellimixAutomixChannelQueryVariables> {
    override document = IntellimixAutomixChannelQueryDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const IntellimixDeviceSubscriptionDocument = gql`
    subscription IntellimixDeviceSubscription($id: ID!, $types: [NodeChangeType!]!) {
  nodeChanges(id: $id, types: $types) {
    ...IntellimixDeviceFragment
    ...IntellimixDeviceChangeFragment
  }
}
    ${IntellimixDeviceFragment}
${IntellimixDeviceChangeFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class IntellimixDeviceSubscriptionGQL extends Apollo.Subscription<IntellimixDeviceSubscriptionOpResult, IntellimixDeviceSubscriptionVariables> {
    override document = IntellimixDeviceSubscriptionDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const IntellimixInputChannelSubscriptionDocument = gql`
    subscription IntellimixInputChannelSubscription($id: ID!, $types: [NodeChangeType!]!) {
  nodeChanges(id: $id, types: $types) {
    ...IntellimixInputChannelFragment
    ...IntellimixInputChannelChangeFragment
  }
}
    ${IntellimixInputChannelFragment}
${IntellimixInputChannelChangeFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class IntellimixInputChannelSubscriptionGQL extends Apollo.Subscription<IntellimixInputChannelSubscriptionOpResult, IntellimixInputChannelSubscriptionVariables> {
    override document = IntellimixInputChannelSubscriptionDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const IntellimixBasicAutomixChannelSubscriptionDocument = gql`
    subscription IntellimixBasicAutomixChannelSubscription($id: ID!, $types: [NodeChangeType!]!) {
  nodeChanges(id: $id, types: $types) {
    ...IntellimixBasicAutomixChannelFragment
    ...IntellimixBasicAutomixChannelChangeFragment
  }
}
    ${IntellimixBasicAutomixChannelFragment}
${IntellimixBasicAutomixChannelChangeFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class IntellimixBasicAutomixChannelSubscriptionGQL extends Apollo.Subscription<IntellimixBasicAutomixChannelSubscriptionOpResult, IntellimixBasicAutomixChannelSubscriptionVariables> {
    override document = IntellimixBasicAutomixChannelSubscriptionDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const IntellimixAutomixChannelSubscriptionDocument = gql`
    subscription IntellimixAutomixChannelSubscription($id: ID!, $types: [NodeChangeType!]!) {
  nodeChanges(id: $id, types: $types) {
    ...IntellimixAutomixChannelFragment
    ...IntellimixAutomixChannelChangeFragment
  }
}
    ${IntellimixAutomixChannelFragment}
${IntellimixAutomixChannelChangeFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class IntellimixAutomixChannelSubscriptionGQL extends Apollo.Subscription<IntellimixAutomixChannelSubscriptionOpResult, IntellimixAutomixChannelSubscriptionVariables> {
    override document = IntellimixAutomixChannelSubscriptionDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const IntellimixEqualizerSubscriptionDocument = gql`
    subscription IntellimixEqualizerSubscription($id: ID!, $types: [NodeChangeType!]!) {
  nodeChanges(id: $id, types: $types) {
    ...IntellimixEqualizerFragment
    ...IntellimixEqualizerFilterChangeFragment
  }
}
    ${IntellimixEqualizerFragment}
${IntellimixEqualizerFilterChangeFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class IntellimixEqualizerSubscriptionGQL extends Apollo.Subscription<IntellimixEqualizerSubscriptionOpResult, IntellimixEqualizerSubscriptionVariables> {
    override document = IntellimixEqualizerSubscriptionDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const IntellimixChannelMutationDocument = gql`
    mutation IntellimixChannelMutation($updates: [NodeUpdateInput!]!, $injectKeyring: String) {
  updateNodes(updates: $updates, keyring: $injectKeyring) {
    ... on AudioChannelOperationResult {
      audioChannel {
        ...IntellimixInputChannelFragment
        ...IntellimixAutomixChannelFragment
      }
      error {
        code
        message
      }
    }
  }
}
    ${IntellimixInputChannelFragment}
${IntellimixAutomixChannelFragment}`;

  @Injectable({
    providedIn: 'root'
  })
  export class IntellimixChannelMutationGQL extends Apollo.Mutation<IntellimixChannelMutationOpResult, IntellimixChannelMutationVariables> {
    override document = IntellimixChannelMutationDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const IntellimixDeviceMutationDocument = gql`
    mutation IntellimixDeviceMutation($updates: [NodeUpdateInput!]!, $injectKeyring: String) {
  updateNodes(updates: $updates, keyring: $injectKeyring) {
    ... on DeviceOperationResult {
      error {
        code
        message
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class IntellimixDeviceMutationGQL extends Apollo.Mutation<IntellimixDeviceMutationOpResult, IntellimixDeviceMutationVariables> {
    override document = IntellimixDeviceMutationDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const IntellimixDeviceOperationModeMutationDocument = gql`
    mutation IntellimixDeviceOperationModeMutation($updates: [NodeUpdateInput!]!, $injectKeyring: String) {
  updateNodes(updates: $updates, keyring: $injectKeyring) {
    ... on DeviceOperationResult {
      error {
        code
        message
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class IntellimixDeviceOperationModeMutationGQL extends Apollo.Mutation<IntellimixDeviceOperationModeMutationOpResult, IntellimixDeviceOperationModeMutationVariables> {
    override document = IntellimixDeviceOperationModeMutationDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const IntellimixDeviceAutomixGainMeteringMutationDocument = gql`
    mutation IntellimixDeviceAutomixGainMeteringMutation($updates: [NodeUpdateInput!]!, $injectKeyring: String) {
  updateNodes(updates: $updates, keyring: $injectKeyring) {
    ... on DeviceOperationResult {
      device {
        features {
          automixGainMetering {
            enabled
          }
        }
      }
      error {
        code
        message
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class IntellimixDeviceAutomixGainMeteringMutationGQL extends Apollo.Mutation<IntellimixDeviceAutomixGainMeteringMutationOpResult, IntellimixDeviceAutomixGainMeteringMutationVariables> {
    override document = IntellimixDeviceAutomixGainMeteringMutationDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResetAutomixerDefaultsMutationDocument = gql`
    mutation ResetAutomixerDefaultsMutation($channelId: ID!, $scope: DeviceResetScope!, $injectKeyring: String) {
  resetDevice(id: $channelId, scope: $scope, keyring: $injectKeyring) {
    ... on DeviceOperationResult {
      error {
        code
        message
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ResetAutomixerDefaultsMutationGQL extends Apollo.Mutation<ResetAutomixerDefaultsMutationOpResult, ResetAutomixerDefaultsMutationVariables> {
    override document = ResetAutomixerDefaultsMutationDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateAutomixerSourceSelectorDocument = gql`
    mutation UpdateAutomixerSourceSelector($input: AutomixSourceSelectorInput!, $injectKeyring: String) {
  updateAutomixSourceSelector(input: $input, keyring: $injectKeyring) {
    error {
      code
      message
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateAutomixerSourceSelectorGQL extends Apollo.Mutation<UpdateAutomixerSourceSelectorOpResult, UpdateAutomixerSourceSelectorVariables> {
    override document = UpdateAutomixerSourceSelectorDocument;
    override client = 'sysApi';
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }